"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptLoader = void 0;
const logger_1 = require("../../helpers/logger");
const helper_1 = require("./helper");
const constants_1 = require("../constants");
const baseScriptLoader_1 = require("../baseScriptLoader");
class ScriptLoader extends baseScriptLoader_1.BaseScriptLoader {
    constructor(scriptConfig) {
        super();
        this.scriptDataSetTag = 'id';
        this.scriptConfig = scriptConfig;
    }
    addScript(script) {
        logger_1.Log.info(`ScriptLoader - Adding script to document  ${script.src}`);
        if (this.scriptConfig.order === constants_1.OrderConfig.TOP) {
            (0, helper_1.addScriptFirstToDocument)(script);
        }
        else if (this.scriptConfig.order === constants_1.OrderConfig.BOTTOM) {
            (0, helper_1.addScriptToDocument)(script);
        }
        else {
            throw Error('ScriptLoader- Incorrect order config');
        }
        logger_1.Log.info(`ScriptLoader s- Added script to document  ${script.src}`);
    }
    getScript(url, onLoad, onError) {
        logger_1.Log.info(`ScriptLoader - Getting script ${url}`);
        let script;
        if (this.scriptConfig.sync === constants_1.SyncConfig.DEFER) {
            script = (0, helper_1.createNewDeferScript)();
        }
        else if (this.scriptConfig.sync === constants_1.SyncConfig.ASYNC) {
            script = (0, helper_1.createNewAsyncScript)();
        }
        else if (this.scriptConfig.sync === constants_1.SyncConfig.DEFAULT) {
            script = (0, helper_1.createNewScript)();
        }
        else {
            throw Error('ScriptLoader - Incorrect sync config');
        }
        script.dataset[`${this.scriptDataSetTag}`] = url;
        script.src = url;
        script.onload = onLoad;
        script.onerror = onError;
        script.type = 'text/javascript';
        // eslint-disable-next-line
        // @ts-ignore
        script.crossorigin = this.scriptConfig.crossorigin || '';
        const additionalConfig = this.scriptConfig.additionalConfig;
        if (additionalConfig) {
            Object.keys(additionalConfig).forEach(key => {
                if (additionalConfig[key]) {
                    script[key] = additionalConfig[key];
                }
            });
        }
        logger_1.Log.info(`ScriptLoader - Get script ${url}`);
        return script;
    }
    isScriptTagInDocument(url) {
        const scripts = document.querySelectorAll(`script[data-${this.scriptDataSetTag}="${url}"]`);
        return scripts.length > 0;
    }
    loadScript(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                logger_1.Log.info(`ScriptLoader - Loading script url ${url}  Config: ${this.scriptConfig}`);
                const script = this.getScript(url, () => this.scriptLoaded(url, resolve), () => this.scriptError(url, reject));
                this.addScript(script);
            });
        });
    }
}
exports.ScriptLoader = ScriptLoader;
//# sourceMappingURL=index.js.map